(() => {
  if (customElements.get('sb-stock-notify')) return;

  class SBStockNotify extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.error = this.querySelector('[role="status"]');
      this.onReady = this.updateReady.bind(this);
      this.onClick = this.openModal.bind(this);
      this.button?.addEventListener('click', this.onClick);
      window.addEventListener('stoq:loaded', this.onReady);
      this.attempts = 0;
      this.updateReady();
      if (!this.ready) {
        this.timer = window.setInterval(() => {
          this.attempts += 1;
          this.updateReady();
          if (this.attempts >= 80) {
            window.clearInterval(this.timer);
            if (!this.ready && this.error) this.error.hidden = false;
          }
        }, 250);
      }
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
      window.removeEventListener('stoq:loaded', this.onReady);
      this.button?.removeEventListener('click', this.onClick);
    }

    updateReady() {
      this.ready = typeof window._RestockRocket?.openModal === 'function';
      if (this.button) this.button.disabled = !this.ready;
      this.dataset.ready = String(this.ready);
      if (this.ready) {
        window.clearInterval(this.timer);
        if (this.error) this.error.hidden = true;
      }
    }

    async openModal() {
      this.updateReady();
      if (!this.ready) return;
      try {
        const product = JSON.parse(this.dataset.product);
        // This button is rendered only for a variant the theme has verified
        // as sold out, including tracked zero stock with continue-selling on.
        const variant = product.variants.find((item) => String(item.id) === this.dataset.variantId);
        if (!variant) throw new Error('Missing notification variant');
        variant.available = false;
        product.available = product.variants.some((item) => item.available);
        await window._RestockRocket.openModal(product, this.dataset.variantId);
      } catch {
        if (this.error) this.error.hidden = false;
      }
    }
  }

  customElements.define('sb-stock-notify', SBStockNotify);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const current = document.getElementById(`SbBuyButtons-${data.sectionId}`);
      const updated = data.html.getElementById(`SbBuyButtons-${data.sectionId}`);
      if (!current || !updated) return;
      const currentPanel = current.querySelector('.sb-stock-panel');
      const updatedPanel = updated.querySelector('.sb-stock-panel');
      current.classList.toggle('sb-buy-buttons--sold-out', Boolean(updatedPanel));
      if (currentPanel) currentPanel.remove();
      if (updatedPanel) current.appendChild(updatedPanel.cloneNode(true));
      const main = document.getElementById(`MainProduct-${data.sectionId}`);
      main?.classList.toggle('sb-product--sold-out', Boolean(updatedPanel));
    });
  }
})();
